export default __webpack_public_path__ + "static/media/whatsappSlide3.144bcbf8.svg";